export type ApiMutationEndpointConfig = {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'
  endpoint: string
}

type ApiMutationEndpointTree = {
  [key: string]: ApiMutationEndpointTree | ApiMutationEndpointConfig
}

export const ApiMutationEndpoint = {
  LOG: {},
  POTS: {
    USE_POT: { endpoint: 'pot_use', method: 'POST' as const },
  },
  BASKET: {
    CREATE_CARD_SETUP: { endpoint: 'user_saved_cards', method: 'POST' as const },
    CHECKOUT:          { endpoint: 'orders',           method: 'POST' as const },
    CREATE_MANDAT:     { endpoint: 'user_mandates',    method: 'POST' as const },
    ADD_PRODUCT:       { endpoint: 'cart_content',           method: 'POST' as const },
    UPDATE_PRODUCT:    { endpoint: 'cart_content/:item_id',  method: 'PUT' as const },
    REMOVE_PRODUCT:    { endpoint: 'cart_content/:item_id',  method: 'DELETE' as const },
    // Suppression multiple en un seul appel/recalcul (action: 'delete_items')
    REMOVE_PRODUCTS_BATCH: { endpoint: 'cart_content',       method: 'POST' as const },
  },
  CATALOG: {
    ADD_PRODUCT_REVIEW: {
      endpoint: '/catalog/products/:productId/reviews',
      method: 'POST' as const,
    },
    // Mesure des blocs de recommandation (lib/recommendTracking.ts)
    RECOMMEND_EVENTS: {
      endpoint: 'recommend_events',
      method: 'POST' as const,
    },
    // Demande de notification de retour en stock (ancien resolver
    // addProductSubscription -> callCsCartApi.post 'AskStockProduct').
    ADD_PRODUCT_SUBSCRIPTION: {
      endpoint: 'AskStockProduct',
      method: 'POST' as const,
    },
  },
  CMS: {},
  COMMUNICATION: {
    SEND_MESSAGE:    { method: 'POST' as const, endpoint: 'communication' },
    MARK_AS_READ:    { method: 'PUT' as const,  endpoint: 'communication/:order_id' },
  },
  DIVISIONS: {},
  // Reponse du pharmacien a une proposition de remplacement de produit (entite CS-Cart
  // PharmeOrderSubstitutions : PUT pharme_order_substitutions/{id} {order_id, decision}).
  ORDER_SUBSTITUTIONS: {
    DECIDE: { method: 'PUT' as const, endpoint: 'order_substitutions/:substitution_id' },
  },
  DISCUSSION: {
    POST_MESSAGE_ADMIN: { endpoint: 'contact_request', method: 'POST' as const },
  },
  TRANSLATION: {},
  ORDERS: {
    RETURN_PRODUCT: { endpoint: 'rma', method: 'POST' as const },
  },
  RMA: {
    UPDATE_DISPUTE: { endpoint: 'rma/:rma_id', method: 'PUT' as const },
    // Actions de resolution/cloture/reouverture du litige (entite PharmeRma).
    // L'URL REST reste `rma/:rma_id` (CS-Cart mappe `rma` -> PharmeRma) ; le
    // comportement est pilote par le champ `action` du payload :
    //   { action: 'choose_promo' } -> { coupon_code, promotion_amount }
    //   { action: 'reopen' }       -> { reopened: true } | 400 si > 15j
    //   { action: 'close' }        -> { closed: true }
    DISPUTE_ACTION: { endpoint: 'rma/:rma_id', method: 'PUT' as const },
    // Pieces jointes du litige (entite enfant PharmeDisputeAttachments).
    // L'upload passe par /api/disputeAttachmentUpload (multipart), pas par le
    // proxy JSON : seule la suppression est une mutation REST classique.
    DELETE_ATTACHMENT: {
      endpoint: 'rma/:rmaId/pharme_dispute_attachments/:attachmentId',
      method: 'DELETE' as const,
    },
  },
  SUBSCRIPTION: {
    CREATE_SUBSCRIPTION: { endpoint: 'user_subscriptions', method: 'POST' as const },
    DELETE_SUBSCRIPTION: { endpoint: 'user_subscriptions/:id', method: 'DELETE' as const },
  },
  AUTH: {
    AUTHENTICATE: { endpoint: 'auth_tokens', method: 'POST' as const },
    SSO_GOOGLE: { endpoint: 'auth_sso_google', method: 'POST' as const },
    SSO_BACKOFFICE: { endpoint: 'auth_sso', method: 'POST' as const },
  },
  USERS: {
    ADD_TO_WISHLIST: { endpoint: 'wish_list', method: 'POST' as const },
    REMOVE_FROM_WISHLIST: { endpoint: 'wish_list', method: 'DELETE' as const },
    UPDATE_PROFILE: { endpoint: 'profile/:user_id', method: 'PUT' as const },
    CHANGE_PASSWORD: { endpoint: 'change_password', method: 'POST' as const },
    REGISTER: { endpoint: 'users', method: 'POST' as const },
    UPDATE_LGO: { endpoint: 'lgo', method: 'POST' as const },
    PASSWORD_RECOVER: { endpoint: 'recover_password', method: 'POST' as const },
    PASSWORD_CHANGE_TOKEN: { endpoint: 'reset_password', method: 'POST' as const },
  },
  COMPANIES: {
    REGISTER: { endpoint: 'vendors', method: 'POST' as const },
  },
  MALINGLISTS: {
    SUBSCRIBE: { endpoint: 'newsletters_subscription', method: 'POST' as const },
    UNSUBSCRIBE: { endpoint: 'newsletters_subscription/:subscriber_id', method: 'DELETE' as const },
  },
} satisfies ApiMutationEndpointTree
